export const cibUnsplash = ["32 32","<path d='M10 9v-9h12v9zM22 14h10v18h-32v-18h10v9h12z'></path>"]